import React from 'react';
import AldagdalDunHolboh from './aldagdalDunHolboh';

const PageList = () => <AldagdalDunHolboh />;

export default PageList;
